//Created by wangshuyi on 07/03/2018.

'use strict';

//plugin
import core from './core/Dol-core'
import auth from './core/Dol-auth'
import dotNetUtil from './core/dol-dotNet-util'
import ajax from './request/Dol-ajax'
import erp from './request/Dol-erp'
import socket from './request/Dol-socket'
import dict from './dict/Dol-dict'
import DolI18n from './display/Dol-i18n'

//component
import DolArrayJoin from './core/dol-array-join'
import DolBoolean from './core/dol-boolean.js'
import DolHighLight from './core/dol-high-light'
import DolIcon from './core/dol-icon'
import DolIsoDate from './core/dol-iso-date'
import DolIsoDatetime from './core/dol-iso-datetime'
import DolDict from './dict/dol-dict.vue'
import DolRow from './layout/dol-row.vue'
import DolCol from './layout/dol-col.vue'
import DolMind from './mind/dol-mind'
import DolMindNode from './mind/dol-mind-node'
import DolSignBox from './signBox/dol-sign-box'
import dolPrice from './display/dolPrice'

//directive
import directive from './core/dol-directive'

export default {
  install(Vue) {
    Vue.prototype.$Dolphin = core;
    Vue.prototype.$auth = auth;
    Vue.prototype.$dotNetUtil = dotNetUtil;
    Vue.prototype.$ajax = ajax;
    Vue.prototype.$erp = erp;
    Vue.prototype.$dolSocket = socket;
    Vue.prototype.$dict = dict;
    Vue.prototype.$dt = DolI18n;

    Vue.component(DolIcon.name, DolIcon);
    Vue.component(DolHighLight.name, DolHighLight);
    Vue.component(DolArrayJoin.name, DolArrayJoin);
    Vue.component(DolBoolean.name, DolBoolean);
    Vue.component(DolIsoDate.name, DolIsoDate);
    Vue.component(DolIsoDatetime.name, DolIsoDatetime);
    Vue.component(DolDict.name, DolDict);
    Vue.component(DolRow.name, DolRow);
    Vue.component(DolCol.name, DolCol);
    Vue.component(DolMind.name, DolMind);
    Vue.component(DolMindNode.name, DolMindNode);
    Vue.component(DolSignBox.name, DolSignBox);
    Vue.component(dolPrice.name, dolPrice);

    directive.forEach(d => Vue.directive(d.name, d.options));
  }
}
